import Header from "../components/Header";
import Footer from "../components/Footer";

function Layout({ children }) {
  return (
    <>
      <Header />
      <main className="flex flex-col w-full mx-auto px-0.5  xl:px-8 overflow-x-hidden min-w-0">
        {children}
      </main>
      <Footer />
    </>
  );
}

export default Layout;
